let Array =  [

			{	
				"Id":1,
				"Topic": "Array",
				"Problem": "Reverse the array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/write-a-program-to-reverse-an-array-or-string/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/reverse-the-array_1262298?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id":2,
				"Topic": "Array",
				"Problem": "Find the maximum and minimum element in an array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/find-minimum-and-maximum-element-in-an-array4428/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/sum-of-max-and-min_1081476?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id": 3,
				"Topic": "Array",
				"Problem": "Find the \"Kth\" max and min element of an array ",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/kth-smallest-element/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/kth-smallest-and-largest-element-of-array_1115488?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id":4,
				"Topic": "Array",
				"Problem": "Given an array which consists of only 0, 1 and 2. Sort the array without using any sorting algo",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/sort-an-array-of-0s-1s-and-2s/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/sort-0-1-2_631055?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id": 5,
				"Topic": "Array",
				"Problem": "Move all the negative elements to one side of the array ",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/move-all-negative-elements-to-end1813/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/move-all-negative-numbers-to-beginning-and-positive-to-end_1112620?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id": 6,
				"Topic": "Array",
				"Problem": "Find the Union and Intersection of the two sorted arrays.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/union-of-two-arrays/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/find-similarities-between-two-arrays_1229070?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id": 7,
				"Topic": "Array",
				"Problem": "Write a program to cyclically rotate an array by one.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/cyclically-rotate-an-array-by-one/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/rotate-array_1230543?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id": 8,
				"Topic": "Array",
				"Problem": "find Largest sum contiguous Subarray [V. IMP]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/kadanes-algorithm/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximum-subarray-sum_630526?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id": 9,
				"Topic": "Array",
				"Problem": "Minimise the maximum difference between heights [V.IMP]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/minimize-the-heights3351/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimize-the-difference_3208652?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id": 10,
				"Topic": "Array",
				"Problem": "Minimum no. of Jumps to reach end of an array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/minimum-number-of-jumps/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-jumps_1062693?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id": 11,
				"Topic": "Array",
				"Problem": "find duplicate in an array of N+1 Integers",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/find-the-duplicate-number/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/duplicate-in-array_893397?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id": 12,
				"Topic": "Array",
				"Problem": "Merge 2 sorted arrays without using Extra space.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/merge-two-sorted-arrays-1587115620/1",
				"URL2": ""
			},
			{
				"Id": 13,
				"Topic": "Array",
				"Problem": "Kadane's Algo [V.V.V.V.V IMP]",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/kadanes-algorithm/0",
				"URL2": ""
			},
			{
				"Id": 14,
				"Topic": "Array",
				"Problem": "Merge Intervals",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/merge-intervals/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/merge-intervals_699917?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id": 15,
				"Topic": "Array",
				"Problem": "Next Permutation",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/next-permutation/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/next-permutaion_893046?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id": 16,
				"Topic": "Array",
				"Problem": "Count Inversion",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/inversion-of-array/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/count-inversions_615?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id": 17,
				"Topic": "Array",
				"Problem": "Best time to buy and Sell stock",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/best-time-to-buy-and-sell-stock/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/stocks-are-profitable_893405?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id": 18,
				"Topic": "Array",
				"Problem": "find all pairs on integer array whose sum is equal to given number",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/count-pairs-with-given-sum5022/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/pair-sum_1171154?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id": 19,
				"Topic": "Array",
				"Problem": "find common elements In 3 sorted arrays",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/common-elements1132/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/common-elements-in-three-sorted-arrays_1113130?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id": 20,
				"Topic": "Array",
				"Problem": "Rearrange the array in alternating positive and negative items with O(1) extra space",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/array-of-alternate-ve-and-ve-nos1401/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/rearrange-alternatively_873851?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id": 21,
				"Topic": "Array",
				"Problem": "Find if there is any subarray with sum equal to 0",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/subarray-with-0-sum/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/subset-sum-equal-to-k_1550954?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id": 22,
				"Topic": "Array",
				"Problem": "Find factorial of a large number",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/factorials-of-large-numbers/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/factorial-of-a-large-number_1115471?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id": 23,
				"Topic": "Array",
				"Problem": "find maximum product subarray ",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/maximum-product-subarray3604/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/maximum-product-subarray_1115474?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id": 24,
				"Topic": "Array",
				"Problem": "Find longest consecutive subsequence",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/longest-consecutive-subsequence/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/longest-consecutive-sequence_759408?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id": 25,
				"Topic": "Array",
				"Problem": "Given an array of size n and a number k, find all elements that appear more than \" n/k \" times.",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/majority-element-ii/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/elements-occur-more-than-n-k-times_1113146?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id": 26,
				"Topic": "Array",
				"Problem": "Maximum profit by buying and selling a share atmost twice",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/best-time-to-buy-and-sell-stock-iii/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/buy-and-sell-stock_1071012?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id": 27,
				"Topic": "Array",
				"Problem": "Find whether an array is a subset of another array",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/array-subset-of-another-array/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/check-subset_762948?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id": 28,
				"Topic": "Array",
				"Problem": "Find the triplet that sum to a given value",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/triplet-sum-in-array/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/triplets-with-given-sum_893028?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id": 29,
				"Topic": "Array",
				"Problem": "Trapping Rain water problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/trapping-rain-water/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/trapping-rainwater_630519?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id": 30,
				"Topic": "Array",
				"Problem": "Chocolate Distribution problem",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/chocolate-distribution-problem/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/chocolate-problem_893280?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id": 31,
				"Topic": "Array",
				"Problem": "Smallest Subarray with sum greater than a given value",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/minimum-size-subarray-sum/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/rahul-and-minimum-subarray_1551987?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id": 32,
				"Topic": "Array",
				"Problem": "Three way partitioning of an array around a given value",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/three-way-partitioning/1",
				"URL2": "https://www.codingninjas.com/codestudio/problems/three-way-partition_1170519?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id": 33,
				"Topic": "Array",
				"Problem": "Minimum swaps required bring elements less equal K together",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://practice.geeksforgeeks.org/problems/minimum-swaps-required-to-bring-all-elements-less-than-or-equal-to-k-together/0",
				"URL2": "https://www.codingninjas.com/codestudio/problems/minimum-swaps-to-bring-all-elements-less-than-or-equal-to-k-together_1112657?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id": 34,
				"Topic": "Array",
				"Problem": "Minimum no. of operations required to make an array palindrome",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/minimum-number-of-moves-to-make-palindrome/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/make-it-palindrome_3189160?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id": 35,
				"Topic": "Array",
				"Problem": "Median of 2 sorted arrays of equal size",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://www.geeksforgeeks.org/median-of-two-sorted-arrays/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/find-the-median-of-all-subarrays-of-a-particular-size_1229069?topList=love-babbar-dsa-sheet-problems"
			},
			{
				"Id": 36,
				"Topic": "Array",
				"Problem": "Median of 2 sorted arrays of different size",
				"Done": false,
				"Bookmark": false,
				"Notes": "",
				"URL": "https://leetcode.com/problems/median-of-two-sorted-arrays/",
				"URL2": "https://www.codingninjas.com/codestudio/problems/median-of-two-sorted-arrays_985294?topList=love-babbar-dsa-sheet-problems"
			}
];
export default Array;
export const version = 100000028;
